module.exports = __webpack_public_path__ + "static/img/Nuernberger-logo.9eb6fcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Nuernberger-logo.png
// module id = S7IL
// module chunks = 1